import axios from 'axios';

import config from '../config';

const serverUri = config.getServerUri();

export default (routeString, queryString, dataObj) => new Promise((resolve, reject) => {
  const { token } = localStorage;
  const query = queryString ? `?${queryString}` : '';
  axios.patch(`${serverUri}${routeString}${query}`, dataObj, {
    headers: {
      authorization: token,
    },
  }).then((res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
